import React, { useState, useEffect, useRef } from "react";

import PerfectScrollbar from "react-perfect-scrollbar";
import { makeStyles } from "@mui/styles";
import { styled } from "@mui/material/styles";

import CircularProgress from "@mui/material/CircularProgress";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import clsx from "clsx";
import {
  Card,
  Grid,
  TextField,
  FormControlLabel,
  Switch,
  Button,
  Typography,
  CardContent,
} from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";

import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import { MenuToolbar } from "./components";
import { useSelector, useDispatch } from "react-redux";

import { authMiddleWare } from "util/auth";
import { useHistory } from "react-router-dom";
import {
  saveMenu,
  clearAPIStatus,
  getMyMenu,
  updateMenu,
} from "store/actions/restaurantMenu";
import {
  showSuccessSnackbar,
  showErrorSnackbar,
} from "store/actions/snackbarMessage";
import API from "util/API";
import { BackButton } from "components";
import { CSVLink } from "react-csv";


const IOSSwitch = styled(Switch)(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  margin: theme.spacing(1),
  "& .MuiSwitch-switchBase": {
    padding: 1,
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: theme.palette.common.white,
      "& + .MuiSwitch-track": {
        backgroundColor: "#52d869",
        opacity: 1,
        border: "none",
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#52d869",
      border: "6px solid #fff",
    },
  },
  "& .MuiSwitch-thumb": {
    width: 24,
    height: 24,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
}));

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    backgroundColor: "#f7f7f7",
  },
  content: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(3),
  },
  inner: {
    minWidth: 1050,
  },
  leftContainer: {
    flex: 1,
    alignItems: "left",
  },
  rightContainer: {
    display: "flex",
    alignItems: "right",
  },
  avatar: {
    marginRight: theme.spacing(2),
  },
  uploadButton: {
    marginLeft: "4px",
    margin: theme.spacing(1),
  },
  actions: {
    justifyContent: "flex-end",
  },
  textLink: {
    textDecoration: "underline",
  },
  actionButton: {
    margin: theme.spacing(1),
    minWidth: '200px',
    textTransform: 'none',
    boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
    '&:hover': {
      boxShadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)',
    },
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  buttonWrapper: {
    position: 'relative',
    display: 'inline-block',
  },
}));

const Menu = (props) => {
  const { className, ...rest } = props;
  const classes = useStyles();
  const groupCSVLinkRef = useRef();
  const itemCSVLinkRef = useRef();

  const dispatch = useDispatch();
  const history = useHistory();
  const [buttonLoading, setButtonLoading] = useState(false);
  const saveTheMenu = (menu) => dispatch(saveMenu(menu));
  const updateTheMenu = (menu, menuId) => dispatch(updateMenu(menu, menuId));
  const clearApiStatus = () => dispatch(clearAPIStatus());
  const loadMenu = (menuId) => dispatch(getMyMenu(menuId));
  const [fileError, setFileError] = useState(null);
  const [csvFile, setCsvFile] = useState(null);
  const [content, setContent] = useState(null);
  const [groups, setGroups] = useState([]);
  
  const [groupsDownloaded, setGroupsDownloaded] = useState(false);
  const [items, setItems] = useState([]);
  const [itemsDownloaded, setItemsDownloaded] = useState(false);
  const [showStoreSelector, setShowStoreSelector] = useState(false);
  const [stores, setStores] = useState([]);
  const [selectedStoreId, setSelectedStoreId] = useState('');
  const [pendingUploadType, setPendingUploadType] = useState(null);
  const showError = (msg) => dispatch(showErrorSnackbar(msg));
  const showSuccess = (msg) => dispatch(showSuccessSnackbar(msg));

  const error = useSelector((state) => state.restaurantMenu.err);
  const apiSuccess = useSelector((state) => state.restaurantMenu.apiSuccess);
  const menu = useSelector((state) => state.restaurantMenu.menu);

  const menuId = props.match.params.menuId;

  const handleFileChange = (event) => {
    setCsvFile(event.target.files[0]);
  };

  const setIsForHubster = (value) => {
     setValues({ ...values, isForHubster: value });
  }

  const fileHandler = async (event, type) => {
    event.preventDefault();
    if (csvFile === null) {
      showError("Please choose a csv file.");
      return;
    }
    setButtonLoading(true);

    let formData = new FormData();
    formData.append("file", csvFile);
    formData.append("content", content);
    try {
      await API.post(`/uploadMenu/${menuId}/${type}`, formData, {
        headers: {
          "content-type": "multipart/form-data",
        },
      });

      setButtonLoading(false);
      showSuccess("Uploaded successfully");
      window.location.reload();
    } catch (error) {
      if (error && error.response && error.response.status === 403) {
        history.push("/login");
      }
      console.log(error);
      setButtonLoading(false);
      setFileError("Error in posting the data");
      showError("Something went wrong, please try again.");
    }
  };

  useEffect(() => {
    if (groups.length > 0 && groupsDownloaded === true) {
      groupCSVLinkRef.current.link.click();
    }
  }, [groups, groupsDownloaded]);


  useEffect(() => {
    if (items.length > 0 && itemsDownloaded === true) {
      itemCSVLinkRef.current.link.click();
    }
  }, [items, itemsDownloaded]);

  const downloadMenu = async (event, type) => {
    event.preventDefault();
    setButtonLoading(true);

    try {
      const response = await API.get(`/downloadMenuCSV/${menuId}/${type}`);

      setButtonLoading(false);
      setItemsDownloaded(false);
      setGroupsDownloaded(false);

      console.log(response.data);
      if (type === "group") {
        if (response.data && response.data.allGroups) {
          setGroups(response.data.allGroups);
          setGroupsDownloaded(true);
        }
      }

      if (response.data && response.data.allItems) {
        setItems(response.data.allItems);
        setItemsDownloaded(true);
      }
      // console.log(done);
      // done();
    } catch (error) {
      if (error && error.response && error.response.status === 403) {
        history.push("/login");
      }
      console.log(error);
      setButtonLoading(false);
      showError("Something went wrong, please try again.");
    }
  };

  if (error && error !== null) {
    clearApiStatus();
  }

  if (apiSuccess) {
    clearApiStatus();
    history.push("/myMenus");
  }

  useEffect(() => {
    if (!menu || !menuId) {
      return;
    }
    setValues({ ...menu });
  }, [menu, menuId]);

  useEffect(() => {
    const menuId = props.match.params.menuId;
    if (menuId && menuId.length > 0) {
      loadMenu(menuId);
    }
  }, [props]);

  const initialState = {
    menuName: "",
    menuDescription: "",
    isMainMenu: false,
    isSecondaryMenu: false,
    isThirdMenu: false,
    isFourthMenu: false,
    isFifthMenu: false,
    isDefault: false,
    isForHubster: false,
    isSixthMenu: false,
    isMenuVersion2: false,
    qrCodeType: "",
  };

  const [values, setValues] = useState(initialState);

  const handleInputChange = (e) => {
    e.preventDefault();
    const { name, value, type } = e.target;
    //console.log('name', name, value, type);
    if (type === "checkbox") {
      setValues({ ...values, [name]: !values[name] });
    } else {
      setValues({ ...values, [name]: value });
    }
  };

  const handleMainMenuChange = (e) => {
    if (e.target.checked) {
      setValues({
        ...values,
        isSecondaryMenu: false,
        isMainMenu: true,
        isThirdMenu: false,
        isFourthMenu: false,
        isFifthMenu: false,
        isSixthMenu: false,
      });
    } else {
      setValues({ ...values, isMainMenu: false });
    }
  };

  const handleSecondaryMenuChange = (e) => {
    if (e.target.checked) {
      setValues({
        ...values,
        isSecondaryMenu: true,
        isMainMenu: false,
        isThirdMenu: false,
        isFourthMenu: false,
        isFifthMenu: false,
        isSixthMenu: false,
      });
    } else {
      setValues({ ...values, isSecondaryMenu: false });
    }
  };

  const handleThirdMenuChange = (e) => {
    if (e.target.checked) {
      setValues({
        ...values,
        isSecondaryMenu: false,
        isMainMenu: false,
        isThirdMenu: true,
        isFourthMenu: false,
        isFifthMenu: false,
        isSixthMenu: false,
      });
    } else {
      setValues({ ...values, isThirdMenu: false });
    }
  };

  const handleFourthMenuChange = (e) => {
    if (e.target.checked) {
      setValues({
        ...values,
        isSecondaryMenu: false,
        isMainMenu: false,
        isThirdMenu: false,
        isFourthMenu: true,
        isFifthMenu: false,
        isSixthMenu: false,
      });
    } else {
      setValues({ ...values, isFourthMenu: false });
    }
  };

  const handleFifthMenuChange = (e) => {
    if (e.target.checked) {
      setValues({
        ...values,
        isSecondaryMenu: false,
        isMainMenu: false,
        isThirdMenu: false,
        isFourthMenu: false,
        isFifthMenu: true,
        isSixthMenu: false,
      });
    } else {
      setValues({ ...values, isFifthMenu: false });
    }
  };

  const handleSixthMenuChange = (e) => {
    if (e.target.checked) {
      setValues({ ...values, isSixthMenu: true });
    } else {
      setValues({ ...values, isSixthMenu: false });
    }
  };

  const handleQRCodeTypeChange = (event) => {
    setValues({ ...values, qrCodeType: event.target.value });
  };

  const saveMyMenu = () => {
    authMiddleWare(props.history);

    if (menuId && menuId.length > 0) {
      updateTheMenu(values, menuId);
    } else {
      saveTheMenu(values);
    }
  };

  const uploadFantuanMenu = async () => {
   

    if (menuId && menuId.length > 0) {
      try {
        setButtonLoading(true);
         await API.post(`/uploadFantuanMenu/${menuId}`);
        showSuccess("Menu uploaded successfully");
        setButtonLoading(false);

      } catch (error) {
        if (error && error.response && error.response.status === 403) {
          history.push("/login");
        }
        console.log(error);
        setButtonLoading(false);
        showError("Something went wrong, please try again.");
      }
  
    } else {
      console.error("invalid menu Id");
      showError("Something went wrong, please try again.");
    }
  };

  const uploadUberEatsMenu = async (type) => {
    if (menuId && menuId.length > 0) {
      try {
        setButtonLoading(true);
        const response = await API.post(`/uploadUberEatsMenu/${menuId}/${type}`);
        // console.log('UberEats API response:', response.data);
        
        if(response.data && response.data.stores && response.data.stores.length > 0){
          // console.log('Stores found:', response.data.stores);
          setStores(response.data.stores);
          setShowStoreSelector(true);
          setPendingUploadType(type);
          setSelectedStoreId('');
          setButtonLoading(false);
        } else {
          // console.log('No stores found in response, uploading directly');
          showSuccess("Menu uploaded successfully to UberEats");
          setButtonLoading(false);
        }
      } catch (error) {
        if (error && error.response && error.response.status === 403) {
          history.push("/login");
        }
        console.log(error);
        setButtonLoading(false);
        showError("Something went wrong, please try again.");
      }
    } else {
      console.error("invalid menu Id");
      showError("Something went wrong, please try again.");
    }
  };

  const handleStoreSelection = async () => {
    if (!selectedStoreId || selectedStoreId === '') {
      showError("Please select a store to continue");
      return;
    }

    try {
      setButtonLoading(true);
      const response = await API.post(`/uploadUberEatsMenu/${menuId}/${pendingUploadType}`, {
        storeId: selectedStoreId
      });
      
      showSuccess("Menu uploaded successfully to UberEats");
      setButtonLoading(false);
      setShowStoreSelector(false);
      setStores([]);
      setSelectedStoreId('');
      setPendingUploadType(null);
    } catch (error) {
      if (error && error.response && error.response.status === 403) {
        history.push("/login");
      }
      console.log(error);
      setButtonLoading(false);
      showError("Something went wrong, please try again.");
    }
  };

  const handleCancelStoreSelection = () => {
    setShowStoreSelector(false);
    setStores([]);
    setSelectedStoreId('');
    setPendingUploadType(null);
  };

  const uploadHungryPandaMenu = async () => {
    if (menuId && menuId.length > 0) {
      try {
        setButtonLoading(true);
        await API.post(`/uploadHungryPandaMenu/${menuId}`);
        showSuccess("Menu uploaded successfully to Hungry Panda");
        setButtonLoading(false);
      } catch (error) {
        if (error && error.response && error.response.status === 403) {
          history.push("/login");
        }
        console.log(error);
        setButtonLoading(false);
        showError("Something went wrong, please try again.");
      }
    } else {
      console.error("invalid menu Id");
      showError("Something went wrong, please try again.");
    }
  };

  return (
    <Grid className={clsx(classes.root, className)}>
      <BackButton to="/mymenus" label="My Menus" />
      {menu ? <MenuToolbar menuId={menuId} menu={menu} /> : null}

      <Card className={classes.content}>
        <CardContent>
          <PerfectScrollbar>
            <Grid container spacing={3}>
              <Grid item md={5} xs={10}>
                <TextField
                  fullWidth
                  label="Menu name"
                  margin="dense"
                  name="menuName"
                  variant="outlined"
                  value={values.menuName}
                  onChange={handleInputChange}
                />
              </Grid>

              <Grid item md={5} xs={10}>
                <TextField
                  fullWidth
                  label="Menu Description"
                  margin="dense"
                  name="menuDescription"
                  variant="outlined"
                  value={values.menuDescription}
                  onChange={handleInputChange}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <FormControlLabel
                  control={
                    <IOSSwitch
                      checked={values.isMainMenu}
                      onChange={(e) => handleMainMenuChange(e)}
                      name="isMainMenu"
                    />
                  }
                  label="Main Menu"
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <FormControlLabel
                  control={
                    <IOSSwitch
                      checked={values.isSecondaryMenu}
                      onChange={(e) => handleSecondaryMenuChange(e)}
                      name="isSecondaryMenu"
                    />
                  }
                  label="Secondary Menu"
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <FormControlLabel
                  control={
                    <IOSSwitch
                      checked={values.isThirdMenu}
                      onChange={(e) => handleThirdMenuChange(e)}
                      name="isThirdMenu"
                    />
                  }
                  label="Third Menu"
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <FormControlLabel
                  control={
                    <IOSSwitch
                      checked={values.isFourthMenu}
                      onChange={(e) => handleFourthMenuChange(e)}
                      name="isFourthMenu"
                    />
                  }
                  label="Fourth Menu"
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <FormControlLabel
                  control={
                    <IOSSwitch
                      checked={values.isFifthMenu}
                      onChange={(e) => handleFifthMenuChange(e)}
                      name="isFifthMenu"
                    />
                  }
                  label="Fifth Menu"
                />
              </Grid>
              
              <Grid item md={6} xs={12}>
                <FormControlLabel
                  control={
                    <IOSSwitch
                      checked={values.isSixthMenu}
                      onChange={(e) => handleSixthMenuChange(e)}
                      name="isSixthMenu"
                    />
                  }
                  label="Sixth Menu"
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <FormControlLabel
                  control={
                    <Switch
                    checked={values.isForHubster}
                    onChange={(e) => setIsForHubster(e.target.checked)}
                    name="isForHubster"
                    color="primary"
                  />
                  }
                  label="Hubster Menu"
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <FormControlLabel
                  control={
                    <IOSSwitch
                      checked={values.isMenuVersion2}
                      onChange={(e) => setValues({ ...values, isMenuVersion2: e.target.checked })}
                      name="isMenuVersion2"
                    />
                  }
                  label="Menu Version 2"
                />
              </Grid>

              <Grid item md={12} xs={12} xl={12}>
                <FormControl
                  variant="outlined"
                  className={classes.formControl}
                  style={{ minWidth: 150 }}
                >
                  <InputLabel id="demo-simple-select-outlined-label">
                    QR CODE TYPE
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    value={values.qrCodeType}
                    onChange={handleQRCodeTypeChange}
                    label="qrCodeType"
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    <MenuItem value={"pickup-delivery"}>
                      pickup-delivery
                    </MenuItem>
                    <MenuItem value={"takeaway"}>takeaway</MenuItem>
                    <MenuItem value={"pickup"}>pickup</MenuItem>
                    <MenuItem value={"delivery"}>delivery</MenuItem>
                    <MenuItem value={"foodcourt"}>foodcourt</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              {menuId ? (
                <Grid item md={12} xs={12} xl={12}>
                  <div>
                    <Typography gutterBottom variant="h4">
                      Upload menu
                    </Typography>

                    {fileError ? (
                      <div className={classes.customError}>
                        {" "}
                        Wrong forat Format || Supported Format is csv
                      </div>
                    ) : null}
                    <input type="file" onChange={handleFileChange} />
                    <Button
                      variant="outlined"
                      color="primary"
                      type="submit"
                      size="small"
                      startIcon={<CloudUploadIcon />}
                      className={classes.uploadButton}
                      onClick={(event) => fileHandler(event, "group")}
                    >
                      1. Upload menu group csv
                      {buttonLoading && (
                        <CircularProgress
                          size={30}
                          className={classes.progess}
                        />
                      )}
                    </Button>
                    <Button
                      variant="outlined"
                      color="primary"
                      type="submit"
                      size="small"
                      startIcon={<CloudUploadIcon />}
                      className={classes.uploadButton}
                      onClick={(event) => fileHandler(event, "item")}
                    >
                      2. Upload menu items csv
                      {buttonLoading && (
                        <CircularProgress
                          size={30}
                          className={classes.progess}
                        />
                      )}
                    </Button>
                  </div>
                </Grid>
              ) : null}

              <Grid item md={12} xs={12} xl={12}>
                <div>
                  <Typography gutterBottom variant="h4">
                    Download menu
                  </Typography>

                  <CSVLink
                    data={groups}
                    ref={groupCSVLinkRef}
                    filename={`${menuId}-groups.csv`}
                  ></CSVLink>
                  <Button
                    variant="outlined"
                    color="primary"
                    type="submit"
                    size="small"
                    startIcon={<CloudDownloadIcon />}
                    className={classes.uploadButton}
                    onClick={(e) => downloadMenu(e, "group")}
                  >
                    1. Download menu group csv
                    {buttonLoading && (
                      <CircularProgress size={30} className={classes.progess} />
                    )}
                  </Button>

                  <CSVLink
                    data={items}
                    filename={`${menuId}-items.csv`}
                    ref={itemCSVLinkRef}
                  ></CSVLink>
                  <Button
                    variant="outlined"
                    color="primary"
                    type="submit"
                    size="small"
                    startIcon={<CloudDownloadIcon />}
                    className={classes.uploadButton}
                    onClick={(e) => downloadMenu(e, "item")}
                  >
                    2. Download menu items csv
                    {buttonLoading && (
                      <CircularProgress size={30} className={classes.progess} />
                    )}
                  </Button>
                </div>
              </Grid>

              {/* Store Selector Modal */}
              {showStoreSelector && (
                <Grid item md={12} xs={12}>
                  <Card style={{ marginTop: 16, backgroundColor: '#f8f9fa' }}>
                    <CardContent>
                      <Typography variant="h6" gutterBottom>
                        Select a Store
                      </Typography>
                      <Typography variant="body2" color="textSecondary" gutterBottom>
                        Multiple stores found ({stores.length} stores). Please select one store to continue with the UberEats menu upload.
                      </Typography>
                      
                      <FormControl variant="outlined" fullWidth style={{ marginTop: 16, marginBottom: 16 }}>
                        <InputLabel id="store-select-label">Select Store</InputLabel>
                        <Select
                          labelId="store-select-label"
                          value={selectedStoreId}
                          onChange={(e) => setSelectedStoreId(e.target.value)}
                          label="Select Store"
                        >
                          <MenuItem value="">
                            <em>Choose a store...</em>
                          </MenuItem>
                          {(() => {
                            console.log('All stores:', stores);
                            const filteredStores = stores.filter((store) => {
                              console.log('Processing store:', store);
                              const storeId = store.id || store.storeId;
                              const isValid = storeId !== null && storeId !== undefined && storeId !== '';
                              console.log(`Store ID: ${storeId}, Valid: ${isValid}`);
                              return isValid;
                            });
                            console.log('Filtered stores:', filteredStores);
                            
                            // If no stores pass the filter, show all stores with index-based keys
                            const storesToRender = filteredStores.length > 0 ? filteredStores : stores;
                            
                            return storesToRender.map((store, index) => {
                              const storeId = String(store.id || store.storeId || `store-${index}`);
                              const storeName = store.name || store.storeName || `Store ${storeId}`;
                              console.log(`Rendering store - ID: ${storeId}, Name: ${storeName}`);
                              return (
                                <MenuItem key={storeId} value={storeId}>
                                  {storeName}
                                </MenuItem>
                              );
                            });
                          })()}
                        </Select>
                      </FormControl>

                      <div style={{ display: 'flex', gap: 16 }}>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleStoreSelection}
                          disabled={!selectedStoreId || selectedStoreId === '' || buttonLoading}
                          className={classes.actionButton}
                        >
                          Continue
                          {buttonLoading && (
                            <CircularProgress size={24} className={classes.buttonProgress} />
                          )}
                        </Button>
                        <Button
                          variant="outlined"
                          color="secondary"
                          onClick={handleCancelStoreSelection}
                          disabled={buttonLoading}
                        >
                          Cancel
                        </Button>
                      </div>
                    </CardContent>
                  </Card>
                </Grid>
              )}

              <Grid item container md={12} xs={12} spacing={2}>
                <Grid item>
                  <div className={classes.buttonWrapper}>
                    <Button
                      color="primary"
                      variant="contained"
                      className={classes.actionButton}
                      onClick={saveMyMenu}
                      disabled={!values.menuName || buttonLoading}
                    >
                      Save Menu
                      {buttonLoading && (
                        <CircularProgress size={24} className={classes.buttonProgress} />
                      )}
                    </Button>
                  </div>
                </Grid>

                <Grid item>
                  <div className={classes.buttonWrapper}>
                    <Button
                      color="primary"
                      variant="contained"
                      className={classes.actionButton}
                      onClick={uploadFantuanMenu}
                      disabled={buttonLoading || !values.menuName}
                    >
                      Upload to Fantuan
                      {buttonLoading && (
                        <CircularProgress size={24} className={classes.buttonProgress} />
                      )}
                    </Button>
                  </div>
                </Grid>

                <Grid item>
                  <div className={classes.buttonWrapper}>
                    <Button
                      color="primary"
                      variant="contained"
                      className={classes.actionButton}
                      onClick={() => uploadUberEatsMenu('main')}
                      disabled={buttonLoading || !values.menuName}
                    >
                      Upload to UberEats Main Menu
                      {buttonLoading && (
                        <CircularProgress size={24} className={classes.buttonProgress} />
                      )}
                    </Button>
                  </div>
                </Grid>

                <Grid item>
                  <div className={classes.buttonWrapper}>
                    <Button
                      color="primary"
                      variant="contained"
                      className={classes.actionButton}
                      onClick={() => uploadUberEatsMenu('weekend')}
                      disabled={buttonLoading || !values.menuName}
                    >
                      Upload to UberEats Weekend Menu
                      {buttonLoading && (
                        <CircularProgress size={24} className={classes.buttonProgress} />
                      )}
                    </Button>
                  </div>
                </Grid>

                <Grid item>
                  <div className={classes.buttonWrapper}>
                    <Button
                      color="primary"
                      variant="contained"
                      className={classes.actionButton}
                      onClick={uploadHungryPandaMenu}
                      disabled={buttonLoading || !values.menuName}
                    >
                      Upload to Hungry Panda
                      {buttonLoading && (
                        <CircularProgress size={24} className={classes.buttonProgress} />
                      )}
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </PerfectScrollbar>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default Menu;
